require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/classie/classie.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/classie/classie.js
// module id = 703
// module chunks = 0